import { QueryClientProvider } from '@tanstack/react-query'
import posthog from 'posthog-js'
import { PostHogProvider } from 'posthog-js/react'
import React, { PropsWithChildren } from 'react'
import { Provider as ReduxProvider } from 'react-redux'

import { AuthProvider } from '@/auth/components/AuthProvider/AuthProvider'
import { UIProvider } from '@/core/components/UIProvider'
import configureStore from '@/core/store'
import { queryClient } from '@/core/utils/react-query/queryClient'
import LocaleProvider from '@/locale/components/LocaleProvider'
import { ScormAuthProvider } from '@/scorm/components/ScormAuthProvider/ScormAuthProvider'
import isScormEnabled from '@/scorm/utils/isScormEnabled'

import { FeaturesProvider } from './FeaturesProvider'

const store = configureStore({})

function AuthProviders({ children }: React.PropsWithChildren<object>) {
  if (isScormEnabled()) {
    return <ScormAuthProvider>{children}</ScormAuthProvider>
  }

  return <AuthProvider>{children}</AuthProvider>
}

export function AppProviders({ children }: PropsWithChildren) {
  return (
    <UIProvider>
      <ReduxProvider store={store}>
        <QueryClientProvider client={queryClient}>
          <PostHogProvider client={posthog}>
            <LocaleProvider>
              <FeaturesProvider>
                <AuthProviders>{children}</AuthProviders>
              </FeaturesProvider>
            </LocaleProvider>
          </PostHogProvider>
        </QueryClientProvider>
      </ReduxProvider>
    </UIProvider>
  )
}
